import { Box, Typography } from "@mui/material";
import { iconsMap } from "../utils/iconsMap";

type IconListItemProps = {
  title: string;
  text: string;
  color?: string;
  iconSize?: number;
  gap?: number;
  iconName?: keyof typeof iconsMap;
  icon?: React.ReactNode;
  align?: "row" | "column";
};

const IconListItem: React.FC<IconListItemProps> = ({
  title,
  text,
  iconName,
  icon,
  iconSize = 32,
  gap = 2,
  color = "white",
  align = "row",
}) => {
  const IconComponent = iconName
    ? iconsMap[iconName] || iconsMap.CheckCircleIcon
    : null;

  return (
    <Box
      display="flex"
      flexDirection={align}
      alignItems={align === "row" ? "center" : "flex-start"}
      gap={gap}
    >
      {icon ? (
        icon
      ) : IconComponent ? (
        <IconComponent sx={{ fontSize: iconSize, color }} />
      ) : null}
      <Box>
        <Typography variant="h6" color={color} sx={{ fontWeight: 700 }}>
          {title}
        </Typography>
        <Typography variant="body2" color={color}>
          {text}
        </Typography>
      </Box>
    </Box>
  );
};

export default IconListItem;
